import conference from './assets/img/conference.jpg';
import community from './assets/img/community.jpg';
import venue1 from './assets/img/venue1.jpg';
import venue2 from './assets/img/venue2.jpg';
import maskimage from './assets/img/mask-group.png';
import workshop from './assets/img/workshop.jpg';
import participants from './assets/img/participants.jpg';


//page contents
import AboutMdEn from 'contents/about/about.md';
import SponsorEn from 'contents/sponsor/sponsor.md';
import CallsEn from 'contents/calls/calls.md';
import CodeOfConductEn from 'contents/code-of-conduct.md';
import AboutMdFr from 'contents/about/about_fr.md';
import SponsorFr from 'contents/sponsor/sponsor_fr.md';
import CallsFr from 'contents/calls/calls_fr.md';
import CodeOfConductFr from 'contents/code-of-conduct_fr.md';
import VenueFr from 'contents/venue/attending_fr.md';
import VenueEn from 'contents/venue/attending.md';

//sponsors
import OMDTZLogo from './assets/sponsors/Original_OMDTZ_Logo.png';
import HeiGITLogo from './assets/sponsors/HeiGIT_Logo.png';
import HotLogo from './assets/sponsors/HotLogo.jpeg';
import TomTomLogo from './assets/sponsors/TomTomLogo.jpeg';
import DaresSalamUniLogo from './assets/sponsors/DaresSalamUni.jpeg';
import GeoTELogo from './assets/sponsors/GeoTE.png';
import GeOSMLogo from './assets/sponsors/geosm.jpeg';
//blogss
import BlogVenueAnnouncement from 'contents/blogs/venue-announcement.md';
import BlogVenueAnnouncementFr from 'contents/blogs/venue-announcement_fr.md';

export const siteConfiguration = {
	//Conference Information, Landing Page/Hero
	promotionVideo: "https://drive.google.com/file/d/1PwARjRGJyTVk6a66DySleLsoo45bGmfG/preview",
	postConferenceNote: {
		en: 'Thank you for making SotM Africa 2026 a great success! We look forward to your continued support and participation in all our future events.',
		fr: "Merci d'avoir fait de SotM Afrique 2026 un grand succès ! Nous nous réjouissons de votre soutien et de votre participation continus à tous nos événements futurs.",
	},
	conferenceYear: {
		en: 'SotM Africa 2026',
		fr: 'SotM Afrique 2026',
	},
	conferenceTheme: {
		en: 'Mapping The Future: Connecting Communities and Fostering Collaboration.',
		fr: 'Cartographier l\'avenir : connecter les communautés et favoriser la collaboration.',
	},
	heroBackgroundImage: {
		image: venue2,
		alt: "Attribution: Arnold Tibaijuka"
	},
	conferenceDate: {
		en: '26 - 28th June, 2026',
		fr: '26 - 28th June,  2026',
	},
	conferenceLocation: 'Dar es Salaam, Tanzania.',

	//About

	aboutTitle: {
		en: 'About SotM Africa',
		fr: 'À propos de SotM Africa',
	},
	aboutContent: {
		en: `The State of the Map Africa (SotM Africa) is a bi-annual regional conference that celebrates the culture of open mapping, open data, GIS and its impact across Africa. The first SotM Africa conference was hosted by the OSM community in Uganda in 2017.

  This year’s conference in Dar es Salaam, Tanzania will continue to build on the strategy envisioned for OpenStreetMap in Africa as a renewed, strong, and growing network, and as part of the global OpenStreetMap and Open GIS movement.
  `,
		fr: `La conférence State of the Map Africa (SotM Africa) est une conférence régionale organisée tous les deux ans qui se consacre à la mise en valeur de la "cartographie ouverte", des "données ouvertes", des SIG et de leur impact à travers l'Afrique. La première conférence SotM Africa a été organisée par la communauté OSM en Ouganda en 2017.

	La conférence de cette année se tiendra à Dar es Salaam, au Tanzania, et continuera à s'appuyer sur la stratégie envisagée pour OpenStreetMap en Afrique en tant que réseau renouvelé, fort et en pleine croissance, et en tant que partie du mouvement mondial OpenStreetMap et de celui des SIG ouverts.`,
	},
	aboutButton: {
		text: {
			en: 'Learn more',
			fr: 'En savoir plus',
		},
		showArrowIcon: true,
		route: '/about',
		arrowColor: '#fff',
	},

	//Registration
	registrationTitle: {
		en: `Registration`,
		fr: `Inscription`,
	},
	registrationContent: {
		en: `Registration information is coming soon. Stay tuned for updates!`,
		fr: `Les informations relatives à l'inscription seront bientôt disponibles. Restez à l'écoute pour les mises à jour !`,
	},
	ticketTitle: {
		en: `Ticket`,
		fr: `Ticket`,
	},
	earlyBirdEndDate: {
		en: '',//`🔥Early bird ends: 28 june, 2026.`,
		fr: ''//`🔥Fin des inscriptions anticipées : 28 june, 2026.`,
	},

	//Navigation

	navigationLinks: [
		{
			text: {
				en: 'About',
				fr: 'A propos',
			},
			route: '/about',
			isActive: true,
		},
		// {
		// 	text: {
		// 		en: 'Sponsor',
		// 		fr: 'Sponsor',
		// 	},
		// 	route: '/sponsor',
		// 	isActive: true,
		// },
		// {
		// 	text: {
		// 		en: 'Register',
		// 		fr: 'Registre',
		// 	},
		// 	route: '#',
		// 	isActive: true,
		// 	url: 'https://tukiio.com/event/state-of-the-map-africa-2026',
		// 	isURL: true,
		// },
		{
			text: {
				en: 'Travel Grant',
				fr: 'Bourse de voyage',
			},
			isActive: false,
			url: 'https://forms.gle/MBXC9YbLq6k9j6y46',
			isURL: true,
		},
		{
			text: { en: 'Schedule', fr: 'Programme' },
			route: '/schedule',
			isActive: true,
		},
		{
			text: { en: 'Blog', fr: 'Blog' },
			route: '/blog',
			isActive: true,
		},
		{
			text: {
				en: 'Photo Gallery',
				fr: 'Galerie de photos',
			},
			route: '#',
			isActive: true,
			url: 'https://silverink.smugmug.com/2026/CORPORATE/n-rGsQVC/OpenMap-Development-Tanzania',
			isURL: true,
		},
		{
			text: {
				en: 'Statistics',
				fr: 'Statistiques',
			},
			route: '#',
			isActive: true,
			url: 'https://www.canva.com/design/DAHN1ac9E-U/BJtqeE8gTM5jftUB74vMNQ/view?utm_content=DAHN1ac9E-U&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h1f10674ec7#18',
			isURL: true,
		},

	],
	navigationButtons: [
		{
			text: {
				en: 'Suggest a Theme',
				fr: 'Inscription',
			},
			route:
				'https://bit.ly/SotMAfrica2025Theme',
			isActive: false,
			showArrowIcon: true,
			arrowColor: '#fff',
		},
	],
	heroButtons: [
		{
			text: {
				en: 'Photo Gallery',
				fr: 'Galerie de photos',
			},
			route: 'https://silverink.smugmug.com/2026/CORPORATE/n-rGsQVC/OpenMap-Development-Tanzania',
			isActive: true,
			showArrowIcon: true,
			arrowColor: '#fff',
			isURL: true,
		},
		{
			text: {
				en: 'Conference Statistics',
				fr: 'Statistiques de la conférence',
			},
			route: 'https://www.canva.com/design/DAHN1ac9E-U/BJtqeE8gTM5jftUB74vMNQ/view?utm_content=DAHN1ac9E-U&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h1f10674ec7#18',
			isActive: true,
			showArrowIcon: true,
			arrowColor: '#fff',
			isURL: true,
		}
	],
	// Activities
	activityTitle: {
		en: `SotM Africa 2026 will be a 3 days of learning, sharing and fun!`,
		fr: `SotM Afrique 2026 sera une expérience d'apprentissage, de partage et d'amusement de 3 jours!`,
	},

	activities: [
		{
			activityPhoto: `${conference}`,
			activityName: {
				en: 'Conference',
				fr: 'Conférence',
			},
			activityContent: {
				en: `SOTM Africa will bring together participants from around the world to discuss challenges, learn, and celebrate many years of mapping together.`,
				fr: `SOTM Africa regroupera des participants du monde entier pour discuter des défis, apprendre et célébrer de nombreuses années de cartographie ensemble.`,
			},
		},
		{
			activityPhoto: `${workshop}`,
			activityName: {
				en: 'Workshops',
				fr: 'Ateliers',
			},
			activityContent: {
				en: `Featuring full-day of workshops, hands-on experience coupled with learning and sharing!`,
				fr: `Au programme, des ateliers tout au long de la journée, une expérience pratique associée à l'apprentissage et au partage !`,
			},
		},
		{
			activityPhoto: `${community}`,
			activityName: {
				en: 'Community',
				fr: 'Communauté',
			},
			activityContent: {
				en: `The community will meet and have fun!`,
				fr: `Toute la communauté se réunira et prendra du plaisir !`,
			},
		},
	],
	// Venue
	venueTitle: {
		en: 'Venue',
		fr: 'Lieu',
	},

	venueContent: {
		en: 'The conference is scheduled to be hosted at University of Dar es Salaam, the oldest and biggest public university in Tanzania. The venue is located in the western side of Dar es Salaam occupying 1,625 acres on the observation hill, 13 kilometers from the city center. For Visa information, accommodation and more, please click the button below.',
		fr: "La conférence se tiendra à l'Université de Dar es Salaam, la plus ancienne et la plus grande université publique de Tanzanie. Le lieu est situé à l'ouest de Dar es Salaam, sur une colline d'observation de 1 625 acres, à 13 kilomètres du centre-ville. Pour obtenir des informations sur les visas, l'hébergement et plus encore, veuillez cliquer sur le bouton ci-dessous.",
	},
	venueButton: {
		text: {
			en: 'Explore Dar es Salaam',
			fr: 'Visiter Dar es Salaam',
		},
		showArrowIcon: true,
		route: '/venue',
		arrowColor: '#fff',
	},
	venuePhotos: [
		{
			title: 'Conference Hall',
			path: `${venue1}`,
		},
		// {
		// 	title: 'Yaounde Mall',
		// 	path: `${venue2}`,
		// },
	],
	//Pricing

	conferenceTickets: [
		{
			ticketName: {
				en: 'Early Bird',
				fr: "l'oiseau matinal",
			},
			ticketUSDPrice: '75',
			ticketDescription: {
				en: 'Early bird ticket.',
				fr: "billet pour les lève-tôt.",
			},
			ticketBtnText: {
				en: 'Buy Ticket',
				fr: 'Acheter un billet',
			},
			ticketLink:
				'https://tukiio.com/event/state-of-the-map-africa-2026',
		},
		{
			ticketName: {
				en: 'Regular',
				fr: 'Regular',
			},
			ticketUSDPrice: '150',

			ticketDescription: {
				en: 'Full access to three days of talks, workshops, and collaborative sessions.',
				fr: "Accès complet à trois jours de conférences, d'ateliers et de sessions collaboratives.",
			},
			ticketBtnText: {
				en: 'Buy Ticket',
				fr: 'Acheter un billet',
			},

			ticketLink:
				'https://tukiio.com/event/state-of-the-map-africa-2026',
		},
		{
			ticketName: {
				en: 'Business',
				fr: 'Business',
			},
			ticketUSDPrice: '350',

			ticketDescription: {
				en: 'For Organizations and businesses.',
				fr: 'For Organizations and businesses.',
			},
			ticketBtnText: {
				en: 'Buy Ticket',
				fr: 'Acheter un billet',
			},

			ticketLink:
				'https://tukiio.com/event/state-of-the-map-africa-2026',
		},
	],

	// Constant website marketing
	WebsiteMarketing: {
		marketingContent: {
			en: 'A conference for OpenStreetMap enthusiasts from all over Africa.',
			fr: "Une conférence pour les passionnés d'OpenStreetMap de toute l'Afrique.",
		},
		picture: maskimage,
	},

	//Map
	Map: {
		LatLng: [-6.7816, 39.20567],
		location: 'Dar es Salaam',
		city: 'Dar es Salaam',
		route: '/venue',
	},

	//Subscribe

	Subscribe: {
		info: {
			en: 'Stay updated on everything SotM Africa',
			fr: 'Restez au courant de toutes les activités de SotM Africa',
		},
		link: 'https://eepurl.com/itbD7k',
		btnName: {
			en: 'Subscribe',
			fr: "S'abonner",
		},
	},

	Schedule: {
		info: {
			en: 'The SotM Africa 2026 conference schedule is now live!',
			fr: 'Le programme de la conférence SotM Africa 2026 est désormais disponible!',
		},
		link: '/schedule',
		btnName: {
			en: 'View Schedule',
			fr: 'Voir le programme',
		},
	},

	//language
	Languages: [
		{
			name: 'English',
			symbol: 'en',
		},
		{
			name: 'French',
			symbol: 'fr',
		},
	],

	//Sponsor

	AllSponsor: [
		{
			package: {
				en: 'Platinum',
				fr: 'Platine',
			},
			color: '#F0900A',
			sponsorsInfo: [
				{
					name: {
						en: 'Humanitarian OpenStreetMap Team',
						fr: 'Humanitarian OpenStreetMap Team',
					},
					logo: HotLogo,
					url: "https://www.hotosm.org/"
				},
			],
		},
		{
			package: {
				en: 'Gold',
				fr: 'Or',
			},
			color: '#FFD700',
			sponsorsInfo: [
				{
					name: {
						en: 'OpenMap Development Tanzania',
						fr: 'OpenMap Development Tanzania',
					},
					logo: OMDTZLogo,
					url: 'linkedin.com/company/openmap-development-tanzania-omdtz',
				},
			],
		},
		{
			package: {
				en: 'Silver',
				fr: 'Argent',
			},
			color: '#C0C0C0',
			sponsorsInfo: [
				{
					name: {
						en: 'Your logo here',
						fr: 'Your logo here',
					},
					logo: "",
				},
			],
		},

		{
			package: {
				en: 'Bronze',
				fr: 'Bronze',
			},
			color: '#CD7F32',
			sponsorsInfo: [
				{
					name: {
						en: 'HeiGIT',
						fr: 'HeiGIT',
					},
					logo: HeiGITLogo,
					url: 'https://www.heigit.org/',
				},
				{
					name: {
						en: 'TomTom',
						fr: 'TomTom',
					},
					logo: TomTomLogo,
					url: 'https://www.tomtom.com/',
				},
				{
					name: {
						en: 'GeOSM',
						fr: 'GeOSM',
					},
					logo: GeOSMLogo,
					url: 'https://www.linkedin.com/company/geosm-family/posts/?feedView=all',
				},
			],
		},
		// {
		// 	package: {
		// 		en: 'Community',
		// 		fr: 'Communauté',
		// 	},
		// 	color: '#F28482',
		// 	sponsorsInfo: [
		// 		{
		// 			name: {
		// 				en: 'Africa Geospatial Solutions',
		// 				fr: 'Africa Geospatial Solutions',
		// 			},
		// 			logo: AGSTomLogo,
		// 			url: 'https://africageospatialsolutions.com/',
		// 		},
				
		// 	],
		// },
		{
			package: {
				en: 'Organisers',
				fr: 'Organisateurs',
			},
			color: '#000',
			sponsorsInfo: [
				{
					name: {
						en: 'OpenMap Development Tanzania',
						fr: 'OpenMap Development Tanzania',
					},
					logo: OMDTZLogo,
					url: 'https://www.omdtz.or.tz',
				},
				{
					name: {
						en: 'GeoTE',
						fr: 'GeoTE',
					},
					logo: GeoTELogo,
					url: 'https://www.geote.org/',
				},
				{
					name: {
						en: 'University of Dar es Salaam',
						fr: 'Université de Dar es Salaam',
					},
					logo: DaresSalamUniLogo,
					url: 'https://www.udsm.ac.tz/',
				},
			],
		},

	],

	// Sponsorship Prospectus
	sponsorProspectusText: {
		en: 'Join us in shaping the future of open mapping in Africa. Discover unique sponsorship opportunities to showcase your brand and make a lasting impact at SotM Africa 2026.',
		fr: "Rejoignez-nous pour façonner l'avenir de la cartographie ouverte en Afrique. Découvrez des opportunités de sponsoring uniques pour mettre en valeur votre marque et laisser une empreinte durable à SotM Afrique 2026.",
	},

	sponsorProspectusActionButton: {
		en: 'Explore Sponsorship Opportunities',
		fr: 'Découvrez les opportunités de sponsoring',
	},

	//Footer

	footer: [
		{
			title: {
				en: 'SotM Africa',
				fr: 'SotM Afrique',
			},
			isActive: true,
			links: [
				{
					text: {
						en: 'About',
						fr: 'A propos',
					},
					link: '/about',
					isURL: false,
				},
				// {
				// 	text: { en: 'Blog', fr: 'Blog' },
				// 	link: '/blog',
				// 	isURL: false,
				// },
				{
					text: { en: 'Sponsor', fr: 'Sponsor' },
					link: '/Sponsor',
					isURL: false,
				},
				// {
				// 	text: { en: 'Submit a Talk', fr: 'Soumettre une Présentation' },
				// 	link: 'https://pretalx.com/state-of-the-map-africa-2025/cfp',
				// 	isURL: true,
				// },
			],
		},
		{
			title: {
				en: 'Quick Links',
				fr: 'Liens utiles',
			},
			isActive: true,
			links: [
				// {
				// 	text: {
				// 		en: 'Call for Speakers',
				// 		fr: 'Appel aux intervenants',
				// 	},
				// 	link: '/calls',
				// 	isURL: false,
				// },
				// {
				// 	text: {
				// 		en: 'Travel Grant',
				// 		fr: 'Bourse de voyage',
				// 	},
				// 	link: 'https://forms.gle/MBXC9YbLq6k9j6y46',
				// 	isURL: true,
				// },
				{
					text: {
						en: 'Schedule',
						fr: 'Programme',
					},
					link: '/schedule',
					isURL: false,
				},
				{
					text: {
						en: 'Explore Dar es Salaam',
						fr: 'Visiter Dar es Salaam',
					},
					link: '/venue',
					isURL: false,
				},
				{
					text: {
						en: 'Photo Gallery',
						fr: 'Galerie de photos',
					},
					link: 'https://silverink.smugmug.com/2026/CORPORATE/n-rGsQVC/OpenMap-Development-Tanzania',
					isURL: true,
				},
				{
					text: {
						en: 'Statistics',
						fr: 'Statistiques',
					},
					link: 'https://www.canva.com/design/DAHN1ac9E-U/BJtqeE8gTM5jftUB74vMNQ/view?utm_content=DAHN1ac9E-U&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h1f10674ec7#18',
					isURL: true,
				},
				// {
				// 	text: 'Travel Grant',
				// 	link: '',
				// 	isURL: false,
				// },
			],
		},
		{
			title: {
				en: 'Follow us',
				fr: 'Suivez-nous',
			},
			isActive: true,
			links: [
				{
					text: {
						en: 'Twitter',
						fr: 'Twitter',
					},
					link: 'https://twitter.com/sotmafrica',
					isURL: true,
				},
				{
					text: { en: 'Facebook', fr: 'Facebook' },
					link: 'https://www.facebook.com/sotmafrica/?_rdc=1&_rdr',
					isURL: true,
				},
				{
					text: { en: 'LinkedIn', fr: 'LinkedIn' },
					link: 'https://www.linkedin.com/company/sotmafrica',
					isURL: true,
				}, {
					text: { en: 'Telegram', fr: 'Telegram' },
					link: 'https://t.me/sotmafrica',
					isURL: true,
				},
				{
					text: { en: 'YouTube', fr: 'Facebook' },
					link: 'https://www.youtube.com/@sotmafrica',
					isURL: true,
				},
			],
		},
		{
			title: {
				en: 'Contact us',
				fr: 'Contactez nous',
			},
			isActive: true,
			links: [
				{
					text: { en: 'Email', fr: 'Email' },
					link: 'contact@stateofthemap.africa',
					isURL: false,
					isEmail: true,
				},
				{
					text: { en: 'Wiki page', fr: 'Wiki page' },
					link: 'https://wiki.openstreetmap.org/wiki/State_of_the_Map_Africa_2025',
					isURL: true,
				},
				{
					text: {
						en: 'OSM Africa',
						fr: 'OSM Afrique',
					},
					link: '',
					isURL: false,
				},
				{
					text: {
						en: 'Code of conduct',
						fr: 'Code de conduite',
					},
					link: '/code-of-conduct',
					isURL: false,
				},
			],
		},
	],
	footerLogoURL: '/',
	copyright: {
		en: '© 2026 Technical and Communications Committee · SotM Africa',
		fr: '© 2026 Commission technique et de la communication - SotM Afrique',
	},

	// Pages
	//About
	About: {
		title: {
			en: 'About SotM Africa',
			fr: 'A propos de SotM Afrique',
		},
		picture: participants,
	},

	//Sponsors
	Sponsor: {
		title: {
			en: 'SotM Africa Sponsorship',
			fr: 'Sponsoring du SotM Afrique',
		},
		picture: participants,
	},

	//Code of Conduct
	CodeOfConduct: {
		title: {
			en: 'SotM Africa Code of Conduct',
			fr: 'Code de conduite de SotM Afrique',
		},
		picture: participants,
	},

	//Programme
	Programme: {
		title: {
			en: 'SotM Africa 2026 Conference Schedule',
			fr: 'Programme SotM Afrique 2026',
		},
		picture: participants,
	},

	// Calls
	Calls: {
		title: {
			en: 'Call for Participation',
			fr: "Appel à manifestation d'intérêt",
		},
		picture: participants,
	},

	//Venue
	Venue: {
		title: {
			en: 'Explore Dar es Salaam',
			fr: 'Visiter Dar es Salaam',
		},
		picture: venue1,
	},

	//Blog

	blogs: {
		fr: [
			{
				title: "La conférence sur l'état de la carte 2026 se tiendra à Dar es Salaam, en Tanzanie",
				date: '11 Février 2026',
				image: venue2,
				route: '/blog/sotm-venue-announcement',
				preview: `Du 26 au 28th juin, 2026, la communauté OSM Afrique se réunira pour une autre conférence passionnante : State of the Map Africa 2026. Cette conférence vise à rassembler les passionnés d'OpenStreetMap d'Afrique et d'ailleurs...`,
			},
		],
		en: [
			{
				title: 'State of the Map Africa 2026 will be held in Dar es Salaam, Tanzania',
				date: 'February 11, 2026',
				image: venue2,
				route: '/blog/sotm-venue-announcement',
				preview: `From  26 to 28th June 2026, the OSM Africa community will be coming together for yet another exciting conference: State of the Map Africa 2026. The conference aims to bring together OpenStreetMap enthusiasts from Africa and beyond...`,
			},
		],

	},

	//page contents

	contentfilePathMapping: {
		en: {
			about: AboutMdEn,
			sponsor: SponsorEn,
			calls: CallsEn,
			'code-of-conduct': CodeOfConductEn,
			venue: VenueEn,
			'sotm-venue-announcement': BlogVenueAnnouncement,
		},
		fr: {
			about: AboutMdFr,
			sponsor: SponsorFr,
			calls: CallsFr,
			'code-of-conduct': CodeOfConductFr,
			venue: VenueFr,
			'sotm-venue-announcement': BlogVenueAnnouncementFr,
		},
	},
};
